/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for unfilled-star icon.
 *
 * @author Ramani Govindaraju
 */
const UnfilledStar = props => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M24 0H0v24h24z" />
      <path
        fill="#6A7070"
        d="M12 19.176l4.885 2.684c.584.321 1.307.086
        1.615-.525a1.3 1.3 0 0 0 .12-.793l-.933-5.685
        3.952-4.026a1.29 1.29 0 0 0 .021-1.768 1.179
        1.179 0 0 0-.684-.364l-5.461-.83-2.442-5.172c-.293-.619-1.01-.873-1.602-.568a1.224
        1.224 0 0 0-.543.568L8.485 7.87l-5.46.83c-.655.1-1.107.733-1.012
        1.417.037.272.16.523.348.715l3.952 4.026-.933 5.685c-.111.68.326 1.327.977
        1.444.259.046.526.002.758-.126L12 19.176zm0-2.326l-4.254 2.236a.25.25
        0 0 1-.363-.263l.813-4.737-3.442-3.355a.25.25 0 0 1 .139-.426l4.756-.691 2.127-4.31a.25.25
        0 0 1 .448 0l2.127 4.31 4.756.691a.25.25 0 0 1 .139.426l-3.442 3.355.813 4.737a.25.25
        0 0 1-.363.263L12 16.85z"
      />
    </g>
  </SvgIcon>
);

export default UnfilledStar;



// WEBPACK FOOTER //
// ./src/js/icons/UnfilledStar.jsx